export const normalizeProjectionId = (value) => {
  if (value == null || value === "") return null;
  const numericValue = Number(value);
  return Number.isNaN(numericValue) ? String(value) : numericValue;
};

export const getProjectedColumnKey = (item, isRoomFilterActive = false) => {
  if (!item) return null;

  const rawValue = isRoomFilterActive
    ? (item.roomId ?? item.room_id ?? item.room?.value ?? item.room ?? item.columnKey ?? null)
    : (
        item.therapistId ??
        item.therapist_id ??
        item.therapist ??
        item.selected_therapist?.value ??
        item.columnKey ??
        null
      );

  return normalizeProjectionId(rawValue);
};

export const resolveProjectedColumnIndex = ({
  item,
  headers,
  isRoomFilterActive = false,
  fallbackIndex = -1,
}) => {
  const columnKey = getProjectedColumnKey(item, isRoomFilterActive);

  if (columnKey == null || !Array.isArray(headers) || headers.length === 0) {
    return fallbackIndex;
  }

  const index = headers.findIndex((header) => {
    const headerId = normalizeProjectionId(header?.id);
    return headerId != null && String(headerId) === String(columnKey);
  });

  return index >= 0 ? index : fallbackIndex;
};

export const buildProjectedPlacement = ({
  rowIndex = -1,
  colIndex = -1,
  absoluteStartMinutes = null,
  therapistId = null,
  roomId = null,
  isRoomFilterActive = false,
  extra = {},
}) => ({
  rowIndex,
  colIndex,
  absoluteStartMinutes,
  therapistId: normalizeProjectionId(therapistId),
  roomId: normalizeProjectionId(roomId),
  columnKey: (
    extra?.columnKey ??
    getProjectedColumnKey({ therapistId, roomId }, isRoomFilterActive)
  ),
});

export const buildProjectedDraftSlot = ({
  rowIndex,
  colIndex,
  absoluteStartMinutes,
  duration,
  start_time,
  end_time,
  serviceId,
  serviceName,
  serviceCategoryName,
  counterKey,
  paxIndex,
  therapistId,
  therapistName,
  roomId,
  roomData,
  customer,
  services,
  isPlaceholder,
  isMainBooking,
  isPaxBooking,
  isPax,
  service_at,
  uid,
  isRoomFilterActive = false,
  extra = {},
}) => ({
  ...buildProjectedPlacement({
    rowIndex,
    colIndex,
    absoluteStartMinutes,
    therapistId,
    roomId,
    isRoomFilterActive,
    extra,
  }),
  duration,
  start_time,
  end_time,
  serviceId,
  serviceName,
  serviceCategoryName,
  counterKey,
  paxIndex,
  therapistName,
  roomData: roomData || null,
  customer: customer || null,
  services: Array.isArray(services) ? services : [],
  isPlaceholder: !!isPlaceholder,
  isMainBooking: !!isMainBooking,
  isPaxBooking: !!isPaxBooking,
  isPax: !!isPax,
  service_at,
  uid,
  ...extra,
});

export const buildProjectedOverridePayload = ({
  bookingId,
  itemId,
  start,
  end,
  therapistId,
  therapistName,
  roomId,
  roomName,
  serviceName,
  service_category,
  duration,
  isRequested,
  hasRequestedRoom,
  service_at,
  absoluteStartMinutes,
  guest_checkin_id,
  guest_checkin_name,
  linkedToPrevious,
  scheduleLinkParentKey,
  therapistCleared,
  isRoomFilterActive = false,
  extra = {},
}) => ({
  bookingId,
  itemId,
  start,
  end,
  therapistName,
  roomName,
  serviceName,
  service_category,
  duration,
  isRequested,
  hasRequestedRoom,
  service_at,
  guest_checkin_id,
  guest_checkin_name,
  ...(typeof therapistCleared === "boolean" ? { therapistCleared } : {}),
  ...(linkedToPrevious === false || linkedToPrevious === true
    ? { linkedToPrevious }
    : {}),
  ...(scheduleLinkParentKey != null && scheduleLinkParentKey !== ""
    ? { scheduleLinkParentKey: String(scheduleLinkParentKey) }
    : linkedToPrevious === false
      ? { scheduleLinkParentKey: null }
      : {}),
  ...buildProjectedPlacement({
    absoluteStartMinutes,
    therapistId,
    roomId,
    isRoomFilterActive,
    extra,
  }),
});
